import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Briefcase } from 'lucide-react';
import '../joinComponent/Enroll.css'

const MeetMentors = () => {
    return (
        <div className="meet-mentors-enrollment-container">
            <div className="enrollment-wrapper">
                {/* Career Coaches Card */}
                <div className="enrollment-card career-coach">
                    <div className="card-content">
                        <BookOpen className="card-icon" size={64} />
                        <h2>Career Coaches</h2>
                        <p>Looking for personalized guidance to make informed career choices? Our Career Coaches are here to support you at every step of your journey.</p>

                        <div className="coach-duties">
                            <h3>What a Career Coach Can Do for You:</h3>
                            <ul>
                                <li>Help you assess your strengths and passions</li>
                                <li>Guide you through the process of career exploration</li>
                                <li>Provide tailored advice on your career path and goals</li>
                                <li>Give you insider knowledge of the job market</li>
                                <li>Help you stay motivated and focused on growth</li>
                            </ul>
                        </div>

                        <Link to="/career-coaches" className="join-button">
                            Meet a Career Coach
                        </Link>
                    </div>
                </div>

                {/* Professionals Card */}
                <div className="enrollment-card professional">
                    <div className="card-content">
                        <Briefcase className="card-icon" size={64} />
                        <h2>Professionals</h2>
                        <p>Get advice from experienced industry professionals who can help you navigate the real world of your chosen field.</p>

                        <div className="professional-roles">
                            <h3>Why Connect with a Professional?</h3>
                            <ul>
                                <li>Gain real-world insights and strategies</li>
                                <li>Learn directly from industry veterans who have been where you are</li>
                                <li>Get advice on how to transition from education to the workplace</li>
                                <li>Receive career-specific tips and guidance on navigating challenges</li>
                                <li>Expand your network with influential professionals</li>
                            </ul>
                        </div>

                        <Link to="/professionals" className="join-button">
                            Meet a Professional
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MeetMentors;
